import { Shop } from './../classes/login';
import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  public imageUrlChanged$: EventEmitter<string>;
  public shopStatusChanged$: EventEmitter<Shop>;

  constructor() {
    this.imageUrlChanged$ = new EventEmitter();
    this.shopStatusChanged$ = new EventEmitter();
  }
}
